
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_DISCOUNT_CONDITIONS"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"period"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"period"},"value":{"kind":"Variable","name":{"kind":"Name","value":"period"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"period"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"discount_conditions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promocode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"promocode_status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isCertificate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPromoCodeActivated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"promoCodeApplyingErrorMessage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPromocodeCombineWithDiscount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPromocodeCombineWithAccount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"differenceBetweenPromocodeAndOrder"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPromoCodeExists"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSubscriptionActivated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveriesCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"discountType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"discountValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"discountDuration"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"totals"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cashback_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"referral_amount"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":603}};
    doc.loc.source = {"body":"query GET_DISCOUNT_CONDITIONS($period: String!) {\n  cart(period: $period) {\n    type\n    period\n    discount_conditions {\n        promocode\n        promocode_status\n        isCertificate\n        isPromoCodeActivated\n        promoCodeApplyingErrorMessage\n        isPromocodeCombineWithDiscount\n        isPromocodeCombineWithAccount\n        differenceBetweenPromocodeAndOrder\n        isPromoCodeExists\n        isSubscriptionActivated\n        deliveriesCount\n        discountType\n        discountValue\n        discountDuration\n    }\n    totals {\n        cashback_amount\n        referral_amount\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["GET_DISCOUNT_CONDITIONS"] = oneQuery(doc, "GET_DISCOUNT_CONDITIONS");
        
